import React from 'react';
import { FadeLayer } from './../../styled';
import { Image, VideoWrapper } from './styled';
import assset from './step-3-placeholder.png';

const wrapperStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%'
};

class Step3 extends React.Component {
  constructor() {
    super();
    this.videoListener = this.videoListener.bind(this);
  }

  videoListener = () => {
    this.props.selectStep(4);
  };

  render() {
    if (this.props.currentStep !== 3) {
      return null;
    }
    return (
      <div style={wrapperStyle}>
        <FadeLayer />
        <VideoWrapper>
          {this.props.navigated ? (
            <img src="https://cdn.auth0.com/website/homepage/03_deployment.svg" alt="Deployment" />
          ) : (
            <video
              muted={'true'}
              onEnded={this.videoListener}
              autoPlay="true"
              src="https://videos.ctfassets.net/2ntc334xpx65/WkH8yxoWmQukIMguay8ak/4f753c0162e6f32653669757ab856cfb/03_Deployment.mp4"
            />
          )}
        </VideoWrapper>
      </div>
    );
  }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/Step3/Step3.js